import React from 'react'
import _ from 'lodash'
import { Button, Col, Form, InputNumber, Modal, Row } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import { useDeepEffect } from '../../../utils/hooks'

const DelayForm = (props) => {
  const { formData, visible, onCancel, onOk, form, heroType } = props
  const { getFieldDecorator, validateFields, setFieldsValue, resetFields } =
    form

  useDeepEffect(() => {
    if (!_.isEmpty(formData)) {
      setFieldsValue({
        delaySec: formData.delaySec
      })
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          id: formData.id,
          delaySec: values.delaySec
        }

        onOk(data)
        resetFields()
      }
    })
  }

  return (
    <Modal width={1000} title={heroType} visible={visible} footer={null}>
      <Form onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Delay (วินาที)">
          {getFieldDecorator(`delaySec`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก Delay'
              }
            ]
          })(<InputNumber />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedDelayForm = Form.create({
  name: 'DelayForm'
})(DelayForm)

export default WrappedDelayForm
